module.exports = __webpack_public_path__ + "static/media/hs_04.45bf98f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_04.jpg
// module id = 5935
// module chunks = 0